import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross-green",
  "use": "icon-cross-green-usage",
  "viewBox": "0 0 14.12 14.12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.12 14.12\" id=\"icon-cross-green\"><defs><style>#icon-cross-green .cls-1{fill:#76bc29;}</style></defs><g id=\"icon-cross-green_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-cross-green_圖層_1-2\" data-name=\"圖層 1\"><polygon class=\"cls-1\" points=\"14.12 2.12 12 0 7.06 4.94 2.12 0 0 2.12 4.94 7.06 0 12 2.12 14.12 7.06 9.18 12 14.12 14.12 12 9.18 7.06 14.12 2.12\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol